const config = {
  url: '/locations',
  title: 'Площадки',
  endpoint: '/admin-search?filter=locations',
  type: 'table',
  getUrl: id => `/location/${id}`,
  getApiUrl: id => `/locations/${id}`,
  search: true,
  key: 'locations',
  access: ['*'],
  table: [
    {
      key: 'id',
      width: 75,
      title: 'ID',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.id
    },
    {
      key: 'name',
      width: 150,
      title: 'Название',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.name,
      edit: {
        component: 'Input',
        placeholder: 'Введите',
        maxLength: 255,
        required: true,
      },

    },
  ],
  filters: [],
}

export default config
